var _path, _path2, _path3, _path4, _circle, _circle2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDeliveryColored = function SvgDeliveryColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.333V6H3.333L2 8v3.333h4Z",
    fill: "#E17682"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6v-.667c.368 0 .667.299.667.667H6Zm0 5.333h.667A.667.667 0 0 1 6 12v-.667Zm-4 0V12h-.667v-.667H2ZM2 8h-.667c0-.132.04-.26.112-.37L2 8Zm1.333-2-.554-.37a.667.667 0 0 1 .554-.297V6Zm3.334 0v5.333H5.333V6h1.334ZM6 12H2v-1.333h4V12Zm-4.667-.667V8h1.334v3.333H1.333Zm.112-3.703 1.334-2 1.109.74-1.333 2-1.11-.74Zm1.888-2.297H6v1.334H3.333V5.333Z",
    fill: "#E17682"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.667H6v8.666h8V2.667Z",
    fill: "#FFA0CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.667V2c.368 0 .667.298.667.667H14Zm-8 0h-.667C5.333 2.298 5.632 2 6 2v.667Zm0 8.666V12h-.667v-.667H6Zm8 0h.667V12H14v-.667Zm0-8H6V2h8v1.333Zm-7.333-.666v8.666H5.333V2.667h1.334Zm-.667 8h8V12H6v-1.333Zm7.333.666V2.667h1.334v8.666h-1.334Z",
    fill: "#FFA0CC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.333,
    cy: 1.333,
    r: 1.333,
    transform: "matrix(-1 0 0 1 12.668 10.666)",
    fill: "#9E9E9E",
    stroke: "#9E9E9E",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.333,
    cy: 1.333,
    r: 1.333,
    transform: "matrix(-1 0 0 1 6 10.667)",
    fill: "#9E9E9E",
    stroke: "#9E9E9E",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgDeliveryColored;